import React from 'react';
import cx from 'clsx';
import { Icon } from '@printdeal/ui-library';
import { FormattedMessage } from 'react-intl';

interface ScrollCueProps {
  className?: string;
  title?: string;
  testId?: string;
  onCueClick?: () => void;
}

const ScrollCue = ({
  className, title, testId, onCueClick,
}: ScrollCueProps) => {
  const confirmKeyCodes = [8, 13]; // space, enter

  const handleCueKeyPress = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (typeof onCueClick !== 'function') return;
    if (!confirmKeyCodes.includes(event.keyCode)) return;
    onCueClick();
  };

  const handleCueClick = () => {
    if (typeof onCueClick !== 'function') return;
    onCueClick();
  };

  return (
    <div className={cx(className, 'pd-hidden lg:pd-flex pd-justify-center')}>
      <button type="button" className="pd-absolute pd-top-[calc(-3rem-30px)] pd-m-auto pd-w-max pd-rounded pd-border-0 pd-bg-white pd-px-3 pd-py-2 pd-font-semibold pd-text-dim-600 pd-transition-all pd-duration-150 pd-ease-out after:pd-absolute after:pd-inset-0 after:pd-content-[''] hover:-pd-translate-y-1 hover:pd-text-primary-500 hover:pd-shadow-lg hover:after:-pd-mt-1 focus:pd-text-primary-500 focus:pd-outline-none focus-visible:pd-outline focus-visible:pd-outline-primary-500" onClick={handleCueClick} onKeyDown={handleCueKeyPress}>
        <Icon icon="arrow-down" data-testid={testId || 'arrow-icon'} className="pd-inline pd-text-inherit" />
        {title
          ? <div className="pd-text-sm">{title}</div>
          : (
            <span className="pd-sr-only">
              <FormattedMessage id="general.scrollTeaser.title" defaultMessage="Continue scrolling" />
            </span>
          )}
      </button>
    </div>
  );
};

export default ScrollCue;
